/**
 * Internal dependencies
 */

export function isCombinedField(field) {
  return field.children !== undefined;
}
//# sourceMappingURL=is-combined-field.js.map